import type { MarketType } from '@ps/isp-web-services-types';
import {
  allowedBetTrackingPlayerMarkets,
  restrictedBetTrackingPlayerMarkets
} from '@ps/web-sports-enums';

export const getIsPlayerMarketAllowed = (marketType?: MarketType) =>
  marketType && allowedBetTrackingPlayerMarkets.includes(marketType);

export const getIsPlayerMarketRestricted = (marketType?: MarketType) =>
  marketType && restrictedBetTrackingPlayerMarkets.includes(marketType);
